import range from 'lodash/range';

export default {
    monthNumbers: range(1, 13),
    getYears(count) {
        const thisYear = new Date().getFullYear();
        return range(thisYear, thisYear + 20);
    }
}